module.exports = __webpack_public_path__ + "img/gestao.d61e3ced.png";